
import React from 'react';
import {
  Box, Drawer, IconButton, Button
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import profilecross from "../../../../assets/profilecross.svg";
import CustomText, { textStyles } from '../../../../components/CustomText';
import CustomButton from '../../../../components/CustomButton';
import save from "../../../../assets/save.svg";
import { useEffect,useState } from 'react';
import {toast} from "react-hot-toast";
import SearchableDropdown from "../../../../components/SearchComponent";
import { Country, State, City } from "country-state-city";
import { FormControl } from "@mui/material";
const subscriptionPlans = ["Basic", "Pro", "Advance", "Enterprise"];
const subscriptionStatuses = ["trial", "active", "cancelled"];
const clientStatuses = ["all", "active", "inactive", "requested", "invited"];
const verificationStatuses = ["all", "pending", "verified", "rejected"];

const FilterDrawer = ({ open, onClose, filters, setFilters, onApplyFilters }) => {
  const { t } = useTranslation();
const [localFilters, setLocalFilters] = useState(filters);
const [countries, setCountries] = useState([]);
const [states, setStates] = useState([]);
const [cities, setCities] = useState([]);
const [countriesData, setCountriesData] = useState([]);
const [selectedCountryIso, setSelectedCountryIso] = useState("");

const subscriptionStatusOptions = [  
  { value: "trial", label: "Trial" },
  { value: "active_paid", label: "Active Paid" },
  { value: "active", label: "Active" },
  { value: "free", label: "Free" },
  { value: "expired", label: "Expired" },
  { value: "payment_overdue", label: "Payment Overdue" },
  { value: "inactive", label: "Inactive" },
];

useEffect(() => {
  if (open) {
    setLocalFilters(filters);
  }
}, [open, filters]);
useEffect(() => {
  const list = Country.getAllCountries().map((c) => ({
    name: c.name,
    isoCode: c.isoCode,
  }));

  setCountriesData(list);
  setCountries(list.map((c) => c.name).sort());
}, []);
useEffect(() => {
  if (!open) return;

  const countryName = localFilters.country || "";
  const provinceName = localFilters.province || "";

  if (!countryName) {
    setSelectedCountryIso("");
    setStates([]);
    setCities([]);
    return;
  }

  const countryObj = countriesData.find((c) => c.name === countryName);
  if (!countryObj) {
    setSelectedCountryIso("");
    setStates([]);
    setCities([]);
    return;
  }

  setSelectedCountryIso(countryObj.isoCode);

  const stateList = State.getStatesOfCountry(countryObj.isoCode)
    .map((s) => s.name)
    .sort();

  setStates(stateList);

  if (!provinceName) {
    setCities([]);
    return;
  }

  const stateObj = State.getStatesOfCountry(countryObj.isoCode).find(
    (s) => s.name === provinceName
  );

  if (!stateObj) {
    setCities([]);
    return;
  }

  const cityList = City.getCitiesOfState(
    countryObj.isoCode,
    stateObj.isoCode
  )
    .map((c) => c.name)
    .sort();

  setCities(cityList);
}, [open, localFilters.country, localFilters.province, countriesData]);

const handleCountryChange = (value) => {
  setLocalFilters((prev) => ({
    ...prev,
    country: value,
    province: "",
    city: "",
  }));

  setStates([]);
  setCities([]);

  const obj = countriesData.find((c) => c.name === value);
  if (!obj) return;

  setSelectedCountryIso(obj.isoCode);

  const stateList = State.getStatesOfCountry(obj.isoCode)
    .map((s) => s.name)
    .sort();

  setStates(stateList);
};

const handleProvinceChange = (value) => {
  setLocalFilters((prev) => ({
    ...prev,
    province: value,
    city: "",
  }));

  setCities([]);

  if (!selectedCountryIso) return;

  const stateObj = State.getStatesOfCountry(selectedCountryIso).find(
    (s) => s.name === value
  );
  if (!stateObj) return;

  const cityList = City.getCitiesOfState(
    selectedCountryIso,
    stateObj.isoCode
  )
    .map((c) => c.name)
    .sort();

  setCities(cityList);
};

const handleCityChange = (value) => {
  setLocalFilters((prev) => ({
    ...prev,
    city: value,
  }));
};

const isValidDateRange = (start, end) => {
  if (!start || !end) return true;
  return new Date(end) >= new Date(start);
};

const sectionHeading = {
  fontSize: "15px",
  fontWeight: 600,
  color: "#2C384C",
  mb: 1,
  mt: 2,
  textAlign:"left",
             fontFamily: 'Poppins, sans-serif',

};

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: '100%', sm: 400, md: 550 },
          backgroundColor: '#E7EBEE',
        },
      }}
    >
      <Box sx={{ position: 'sticky', top: 0, backgroundColor: '#E7EBEE', zIndex: 10, px: 2, py: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>
          <CustomText sx={{ ...textStyles.h1, fontSize: 20, fontWeight: 600, color: '#2C384C' }}>
            {t("filterDrawer.title")}
          </CustomText>
        </Box>
      </Box>

      <Box sx={{ px: 2 }}>
        <Box sx={{
          backgroundColor: '#FFFFFF',
          px: 3,
          py: 3,
          height: 'calc(100vh - 90px)',
          overflowY: 'auto',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
        }}>
          {/* Verification Status Filter */}
          <Box sx={{ mt: 3 }}>
            <label className="field_label">{t("filterDrawer.verificationStatus") || "Verification Status"}</label>
            <select
              value={localFilters.verification_status || ""}
              onChange={(e) =>
                setLocalFilters((prev) => ({
                  ...prev,
                  verification_status: e.target.value,
                }))
              }
              className="project_input"
              style={{ width: "100%", height: 40, outline: 'none', border: '1px solid #091E4224', borderRadius: '4px', padding: '0 8px' }}
            >
              <option value="">{t("selectVerificationStatus") || "Select Verification Status"}</option>
              {verificationStatuses.map((status) => (
                <option key={status} value={status}>
                  {status === 'all' ? 'All' : status.charAt(0).toUpperCase() + status.slice(1)}
                </option>
              ))}
            </select>
          </Box>

          



<Box sx={{ mt: 3 }}>
  <label className="field_label">
    {t("subscriptionStatus") || "Subscription Status"}
  </label>

  <select
    value={localFilters.subscription_status || ""}
    onChange={(e) =>
      setLocalFilters((prev) => ({
        ...prev,
        subscription_status: e.target.value,
      }))
    }
    className="project_input"
    style={{
      width: "100%",
      height: 40,
      outline: "none",
      border: "1px solid #091E4224",
      borderRadius: "4px",
      padding: "0 8px",
    }}
  >
    <option value="">
      {t("selectSubscriptionStatus") || "Select Subscription Status"}
    </option>

    {subscriptionStatusOptions.map((opt) => (
      <option key={opt.value} value={opt.value}>
        {opt.label}
      </option>
    ))}
  </select>
</Box>
   

        
<CustomText sx={sectionHeading}>
  {t("filterDrawer.registeredAtDateRange") || "Registered At Date Range"}
</CustomText>
<Box sx={{ display: 'flex', flexDirection: 'row',justifyContent: 'space-between', gap: 2 ,flexWrap:"wrap" }}>

          <Box sx={{ mt: 1 }}>
  <label className="field_label">{t("filterDrawer.startDate") || "Start Date"}</label>
  <input
    type="date"
    value={localFilters.start_date}
    onChange={(e) =>
      setLocalFilters((prev) => ({
        ...prev,
        start_date: e.target.value,
      }))
    }
    className="project_input"
    style={{ width: "100%", height: 40 }}
  />
</Box>

{/* End Date */}
<Box sx={{ mt:1 }}>
  <label className="field_label">{t("filterDrawer.endDate") || "End Date"}</label>
  <input
    type="date"
    value={localFilters.end_date}
    onChange={(e) =>
      setLocalFilters((prev) => ({
        ...prev,
        end_date: e.target.value,
      }))
    }
    className="project_input"
    style={{ width: "100%", height: 40 }}
  />
</Box>
</Box>


{/* Trial Period */}
<CustomText sx={sectionHeading}>
  {t("filterDrawer.trialPeriodDateRange") || "Trial Period Date Range"}
</CustomText>

<Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
  <Box sx={{ flex: 1 }}>
    <label className="field_label">
      {t("filterDrawer.startDate") || "Start Date"}
    </label>
    <input
      type="date"
      value={localFilters.trial_end_date_from || ""}
      onChange={(e) =>
        setLocalFilters((prev) => ({
          ...prev,
          trial_end_date_from: e.target.value,
        }))
      }
      className="project_input"
        style={{ width: "100%", height: 40 }}
    />
  </Box>

  <Box sx={{ flex: 1 }}>
    <label className="field_label">
      {t("filterDrawer.endDate") || "End Date"}
    </label>
    <input
      type="date"
      value={localFilters.trial_end_date_to || ""}
      onChange={(e) =>
        setLocalFilters((prev) => ({
          ...prev,
          trial_end_date_to: e.target.value,
        }))
      }
      className="project_input"
        style={{ width: "100%", height: 40 }}
    />
  </Box>
</Box>


<CustomText sx={sectionHeading}>
  {t("filterDrawer.subscriptionPeriodDateRange") || "Subscription Period Date Range"}
</CustomText>

<Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
  <Box sx={{ flex: 1 }}>
    <label className="field_label">
      {t("filterDrawer.startDate") || "Start Date"}
    </label>
    <input
      type="date"
      value={localFilters.subscription_start_date_from || ""}
      onChange={(e) =>
        setLocalFilters((prev) => ({
          ...prev,
          subscription_start_date_from: e.target.value,
        }))
      }
      className="project_input"
        style={{ width: "100%", height: 40 }}
    />
  </Box>

  <Box sx={{ flex: 1 }}>
    <label className="field_label">
      {t("filterDrawer.endDate") || "End Date"}
    </label>
    <input
      type="date"
      value={localFilters.subscription_start_date_to || ""}
      onChange={(e) =>
        setLocalFilters((prev) => ({
          ...prev,
          subscription_start_date_to: e.target.value,
        }))
      }
      className="project_input"
        style={{ width: "100%", height: 40 }}
    />
  </Box>
</Box>



           <Box sx={{ mt: 2 }}>
          <FormControl    fullWidth 
                        size="small"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: 38,
                            borderRadius: "6px",
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "14px",
                            "& fieldset": {
                              borderColor: "#091E4224",
                              borderWidth: "2px",
                            },
                            "&:hover fieldset": {
                              borderColor: "#1976d2",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#1976d2",
                            },
                          },
                          "& .MuiInputLabel-root": {
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "14px",
                            color: "#6B778C",
                            "&.Mui-focused": {
                              color: "#1976d2",
                            },
                          },
                        }}>
            <label className="field_label">{t("country") || "Country"}</label>
            <SearchableDropdown
              value={localFilters.country || ""}
              onChange={handleCountryChange}
              options={countries}
              placeholder={t("selectCountry") || "Select country"}
            />
          </FormControl>
        </Box>
        
        <Box sx={{ mt: 2 }}>
          <FormControl    fullWidth 
                        size="small"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: 38,
                            borderRadius: "6px",
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "14px",
                            "& fieldset": {
                              borderColor: "#091E4224",
                              borderWidth: "2px",
                            },
                            "&:hover fieldset": {
                              borderColor: "#1976d2",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#1976d2",
                            },
                          },
                          "& .MuiInputLabel-root": {
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "14px",
                            color: "#6B778C",
                            "&.Mui-focused": {
                              color: "#1976d2",
                            },
                          },
                        }}>
            <label className="field_label">{t("province") || "Province/State"}</label>
            <SearchableDropdown
              value={localFilters.province || ""}
              onChange={handleProvinceChange}
              options={states}
              placeholder={t("selectState") || "Select province"}
              disabled={!localFilters.country}
            />
          </FormControl>
        </Box>
        <Box sx={{ mt: 2 }}>
          <FormControl    fullWidth 
                        size="small"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            height: 38,
                            borderRadius: "6px",
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "14px",
                            "& fieldset": {
                              borderColor: "#091E4224",
                              borderWidth: "2px",
                            },
                            "&:hover fieldset": {
                              borderColor: "#1976d2",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#1976d2",
                            },
                          },
                          "& .MuiInputLabel-root": {
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "14px",
                            color: "#6B778C",
                            "&.Mui-focused": {
                              color: "#1976d2",
                            },
                          },
                        }}>
            <label className="field_label">{t("city") || "City"}</label>
            <SearchableDropdown
              value={localFilters.city || ""}
              onChange={handleCityChange}
              options={cities}
              placeholder={t("selectCity") || "Select city"}
              disabled={!localFilters.province}
            />
          </FormControl>
        </Box>

                  <Box sx={{ mt: 4, display: 'flex',flexWrap:"wrap",gap: 2 }}>
            <CustomButton
              onClick={() => {
                const dateRanges = [
                  {
                    start: localFilters.start_date,
                    end: localFilters.end_date,
                    label: t("filterDrawer.registeredAtDateRange") || "Registered At Date Range",
                  },
                  {
                    start: localFilters.trial_end_date_from,
                    end: localFilters.trial_end_date_to,
                    label: t("filterDrawer.trialPeriodDateRange") || "Trial Period Date Range",
                  },
                  {
                    start: localFilters.subscription_start_date_from,
                    end: localFilters.subscription_start_date_to,
                    label: t("filterDrawer.subscriptionPeriodDateRange") || "Subscription Period Date Range",
                  },
                ];

                for (const range of dateRanges) {
                  if (!isValidDateRange(range.start, range.end)) {
                    toast.error(
                      t("filterDrawer.errors.endDateAfterStartWithLabel", {
                        label: range.label,
                      })
                    );
                    return;
                  }
                }
                onApplyFilters(localFilters); 
              }}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <img src={save} alt="save" style={{ width: 16, height: 16 }} />
                  {t("filterDrawer.save")}
                </Box>
              }
              size="medium"
            />
          
            <Button
              variant="outlined"
           onClick={() => {
const clearedFilters = {
  subscription_plan: '',
  subscription_status: '',
  status: '',
  verification_status: '',
  start_date: '',
  end_date: '',
  trial_end_date_from: '',
  trial_end_date_to: '',
  subscription_start_date_from: '',
  subscription_start_date_to: '',
};
      setLocalFilters(clearedFilters);     // Reset the local filter state
      setFilters(clearedFilters);          // Optionally reset global filter state if needed
      onApplyFilters(clearedFilters);      // Apply the cleared filters immediately
    }}
              sx={{
                fontSize: 15,
                textTransform: 'none',
                borderRadius: '5px',
                fontFamily: 'Poppins, sans-serif',
                color: '#006EC2',
                border: "2px solid #006EC2",
                px: 3,
                py: 1,
                height: 'fit-content',
              }}
            >
             {t("filterDrawer.clear")}
            </Button>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default FilterDrawer;
